import React, { ReactNode, useMemo, ReactElement } from 'react'

type Props = {
	space: number
	units?: string
	children: ReactNode
}

export default function MarginComponent({ space, units = 'rem', children }: Props) {
	const style = useMemo(
		() => ({
			margin: space + units,
		}),
		[space, units],
	)
	return (
		<>
			{React.Children.map(children, child =>
				React.cloneElement(child as ReactElement<any>, {
					style: style,
				}),
			)}
		</>
	)
}
